(function($) { 
    $('.team-grid > a').click(function(e){
        if($(window).width() <= 767 && !$(this).hasClass('team-grid--clicked')){
            e.preventDefault();
            $(this).addClass('team-grid--clicked');
            $(this).focus();
        }
    });
})(jQuery);

gsap.registerPlugin(ScrollTrigger)

let windowWidth = window.innerWidth
let windowHeight = window.innerHeight

const methodWrapper = document.querySelector("#method-wrapper")
let methodWrapperHeight = methodWrapper.getBoundingClientRect().height
let methodWrapperWidth = methodWrapper.getBoundingClientRect().width
const methodItemCount = 4
const methodItemGap = 64

window.addEventListener("resize", (event) => {
    windowWidth = window.innerWidth
    windowHeight = window.innerHeight
    methodWrapperHeight = methodWrapper.getBoundingClientRect().height
    methodWrapperWidth = methodWrapper.getBoundingClientRect().width
    methodItemHeight = methodWrapperHeight / 4
})

const howTL = gsap.timeline({
    scrollTrigger: {
        trigger: ".about-how-section",
        start: "top top",
        end: "+=400%",
        scrub: 1,
        pin: true,
        invalidateOnRefresh: true,
        anticipatePin: 0.5,
    },
    defaults: { ease: "power4.inOut", duration: 3 },
})

// if (windowWidth < 900) {
//     howTL
//         .addLabel("start")
//         .to(
//             ".about-how-section",
//             {
//                 backgroundColor: "#EF4872",
//                 duration: 3,
//                 ease: "expo.inOut",
//             }
//         )
//         .addLabel("one")
//         .to(".about-how-section #method-wrapper", {
//             x: -((methodWrapperWidth / methodItemCount) * 1 + methodItemGap * 0.25),
//             delay: 0.5,
//             duration: 3,
//             ease: "expo.inOut",
//         })
//         .to(
//             ".about-how-section",
//             {
//                 backgroundColor: "#C85193",
//                 duration: 3,
//                 ease: "expo.inOut",
//             },
//             "<"
//         )
//         .addLabel("two")
//         .to(".about-how-section #method-wrapper", {
//             x: -((methodWrapperWidth / methodItemCount) * 2 + methodItemGap * 0.5),
//             delay: 0.5,
//             duration: 3,
//             ease: "expo.inOut",
//         })
//         .to(
//             ".about-how-section",
//             {
//                 backgroundColor: "#7B5AA6",
//                 duration: 3,
//                 ease: "expo.inOut",
//             },
//             "<"
//         )
//         .addLabel("three")
//         .to(".about-how-section #method-wrapper", {
//             x: -((methodWrapperWidth / methodItemCount) * 3 + methodItemGap * 0.75),
//             delay: 0.5,
//             duration: 3,
//             ease: "expo.inOut",
//         })
//         .to(
//             ".about-how-section",
//             {
//                 backgroundColor: "#4756A6",
//                 duration: 3,
//                 ease: "expo.inOut",
//             },
//             "<"
//         )
//         .addLabel("end")
// } else {
howTL
    .addLabel("start")
    .to(".about-how-section", {
        backgroundColor: "#EF4872",
    })
    .addLabel("one")
    .to(".about-how-section #method-wrapper", {
        y: -((methodWrapperHeight / methodItemCount) * 1 + methodItemGap / 2),
        delay: 1,
    })
    .to(
        ".about-how-section",
        {
            backgroundColor: "#C85193",
        },
        "<"
    )
    .to(
        ".about-how-section .gradient-block",
        {
            background: "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(200,81,147,1) 18%)",
        },
        "<"
    )
    .addLabel("two")
    .to(".about-how-section #method-wrapper", {
        y: -((methodWrapperHeight / methodItemCount) * 2 + methodItemGap / 2),
        delay: 1,
    })
    .to(
        ".about-how-section",
        {
            backgroundColor: "#7B5AA6",
        },
        "<"
    )
    .to(
        ".about-how-section .gradient-block",
        {
            background: "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(123,90,166,1) 18%)",
        },
        "<"
    )
    .addLabel("three")
    .to(".about-how-section #method-wrapper", {
        y: -((methodWrapperHeight / methodItemCount) * 3 + methodItemGap / 2),
        delay: 1,
    })
    .to(
        ".about-how-section",
        {
            backgroundColor: "#4756A6",
        },
        "<"
    )
    .to(
        ".about-how-section .gradient-block",
        {
            background: "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(71,86,166,1) 18%)",
        },
        "<"
    )
    .to(
        ".about-how-section",
        {
            backgroundColor: "#4756A6",
        },
        ">"
    )
    .addLabel("end")
// }